import type { IContextMutationResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import { useToastStore } from '@modules/toast/store';
import { isString } from '@utils/guards';

import {
  AFFILIATES_PENDING_COUNT_QUERY_KEY,
  AFFILIATES_PENDING_LIST_QUERY_KEY,
  AFFILIATES_PENDING_PERMISSIONS,
  AFFILIATES_PENDING_REJECT_MUTATION_KEY,
  AFFILIATES_PENDING_REJECT_URL,
} from '../constants';

export default function usePendingAffiliatesRejectMutation(): IContextMutationResult<
  void,
  Error,
  number
> {
  const { displayPresetToast } = useToastStore();
  const { fetchPost } = useRestClient();

  return useContextMutation<void, Error, number>({
    mutationKey: [AFFILIATES_PENDING_REJECT_MUTATION_KEY],
    mutationFn: (id) => fetchPost<void>(
      AFFILIATES_PENDING_REJECT_URL,
      {},
      {
        permission: AFFILIATES_PENDING_PERMISSIONS.REQUEST,
        urlParams: { id },
      },
    ),
    onSuccess({ queryClient }) {
      displayPresetToast('success');
      void queryClient.invalidateQueries({
        predicate: (query) => isString(query.queryKey[0]) && [
          AFFILIATES_PENDING_LIST_QUERY_KEY,
          AFFILIATES_PENDING_COUNT_QUERY_KEY,
        ].includes(query.queryKey[0]),
      });
    },
  });
}
